<button [matTooltip]="'PROLONG_SESSION' | translate" class="btn-timer" mat-button (click)="refresh()">
  <mat-icon class="material-icons-outlined">timer</mat-icon>
    {{ timer$ | async }}
</button>
